import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs/internal/Subscription';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { DataService } from '../../dataService';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { ReportsAccountRoutes, typeReportsAccountRoutes } from '../../models/reports.models';
import { ReportService } from '../../reportService';
import { IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from '../../models/reports-data-service-model';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-account-reports',
    templateUrl: './account-reports.component.html',
    styleUrls: ['./account-reports.component.scss']
})
export class AccountReportsComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    //#region Properties
    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any;
    public dateTo: any;
    public reportDate: Date = new Date();
    public pageSize: number = 0;
    public pageNumber: number = 15;

    public cols: any;
    public reportsData = [];
    public totalRecords: number;
    public totalPages: number;
    public results = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    subscription: Subscription = new Subscription();
    //#endregion

    // CTOR
    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private dataService: DataService
    ) {
        // this.subscription = this.dataService.getData().subscribe(data => {
        //     this.onGlobalSearch(data);
        // });

        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                // if (data.value == ReportsTopMenuItemsValues.print) {
                //     this.print();
                // }
                // else if (data.value == ReportsTopMenuItemsValues.PDF) {
                //     this.exportPDF(this.selectedWindow, false);
                // }
                // else if (data.value == ReportsTopMenuItemsValues.XLS) {
                //     this.exportXLS(this.selectedWindow)
                // }
                // else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                //     this.exportXLSX(this.selectedWindow)
                // }
                if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.accountReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
                }
            }
        });
    }

    ngOnInit(): void {
        this.subscription = this.router.paramMap.subscribe((param: any) => {
            const activityType: typeReportsAccountRoutes = param.params.type;
            switch (activityType) {
                case ReportsAccountRoutes.accountsActivityReport:
                    this.selectedWindow = "accountsActivityReport";
                    break;
                case ReportsAccountRoutes.accountsNoActivityReport:
                    this.selectedWindow = "accountsNoActivityReport";
                    break;
                case ReportsAccountRoutes.keyAccountsReportSummary:
                    this.selectedWindow = "keyAccountsReportSummary";
                    break;
                case ReportsAccountRoutes.keyAccountsReportDetails:
                    this.selectedWindow = "keyAccountsReportDetails";
                    break;
                default:
                    break;
            }
            this.accountReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    public accountReport(selectedChannelId: number, companyId: number, userId, currentPageSize: number = 15, currentPageNumber: number = 1, selectedWindow: string, selectedUser: object, selectedOrganizationId: number, searchValue?: any): void {

        this.appMainService.isShowSpinner('AccountReport');
        switch (this.selectedWindow) {
            case 'accountsActivityReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'channelType', header: 'Channel Type' },
                    // { field: 'activityType', header: 'Activity Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'activityCreatedDate', header: 'Created Date' },
                    { field: 'loggedBy', header: 'Created By' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'address', header: 'Address' },

                ];

                // this.cols.push({ field: 'grandTotal', header: 'Grand Total' },);
                //this.selectedWindow ='activityAnalyticReportDetail';
                this.reportName = 'Activity Report';
                break;
            }
            case 'accountsNoActivityReport': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'activityType', header: 'Last Activity Type' },
                    { field: 'comment', header: 'Comment' },
                    { field: 'logdatetimeUTC', header: 'Last Activity Date' },

                    { field: 'repName', header: 'Logged By' },
                    { field: 'territoryName', header: 'Territory Name' },
                    { field: 'address', header: 'Address' },
                ];
                this.reportName = 'No Activity Report';
                break;
            }
            case 'keyAccountsReportSummary': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'noofOpportunity', header: 'No. Of Opportunities' },
                    { field: 'amount', header: 'Amount' },

                ];
                this.reportName = 'Key Accounts Summary';
                break;
            }
            case 'keyAccountsReportDetails': {
                this.cols = [
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'opportunityName', header: 'Opportunity Name' },
                    { field: 'closingDate', header: 'Closing Date' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'amount', header: 'Amount' },

                ];
                this.reportName = 'Key Accounts Details';
                break;
            }

            default: {
                break;
            }
        }
        // this.refresh();
        // this.OrganizationName = this.app.user.organizationName;
        this.reportService.AllAccountReport(selectedChannelId, currentPageSize, currentPageNumber,
            this.formatDate(this.dateFrom),
            this.formatDate(this.dateTo), this.selectedWindow,
            selectedUser, null, null, searchValue).then(res => {
                this.reportsData = [];
                this.totalRecords = 0;
                this.results = [];
                this.totalPages = 0;
                // this.refresh();
                let { contacts, headers } = res;
                this.IsShowReportTemplate = true;
                this.appMainService.isHideSpinner('AccountReport');
                this.reportsData = JSON.parse(JSON.stringify(contacts));

                this.totalRecords = headers['TotalCount'];
                //added for PDF
                this.results = JSON.parse(JSON.stringify(contacts));
                this.totalPages = headers['TotalPages']
                //added for PDF

            }).finally(() => {
                this.appMainService.isHideSpinner('AccountReport');
                this.noContactFindOrLoadingText = 'No Reports Available.';
            });
    }
    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.accountReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
    }

    onClosePanel(selectedWindow: string): void {
    }

    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.accountReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
    }

    onChangeRange(selectedWindow: string, event: any): void {
        //this.selectedDateFilter = event;
        this.accountReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
    }

    onGlobalSearch(searchValue: any) {
        this.accountReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId, searchValue);
    }
}
